import { globalTheme } from '@clds/component-theme';
import { Paper } from '@clds/paper';
import styled from 'styled-components';

export const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  gap: ${globalTheme.spacing.sm};
`;
